import { useState } from "react";
import { faqs } from "@/mocks/loveHelperData";

export default function FaqSection() {
  const [openId, setOpenId] = useState<number | null>(0);

  return (
    <section id="faq" className="mx-auto max-w-7xl px-4 py-16 md:py-20 md:px-6">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <span className="text-sm font-semibold text-primary-600">常见问题</span>
          <h2 className="mt-2 text-2xl font-bold text-foreground-900 md:text-4xl">
            关于这部漫画，你想知道的
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            整理了新读者最常问的问题。如果还有疑问，欢迎通过下方联系方式留言，我们会尽快回复。
          </p>
          <a
            href="#contact"
            className="mt-6 inline-flex whitespace-nowrap items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            联系我们 <i className="ri-mail-line"></i>
          </a>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
            {faqs.map((item, i) => {
              const open = openId === i;
              return (
                <div key={i}>
                  <button
                    type="button"
                    onClick={() => setOpenId(open ? null : i)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    aria-expanded={open}
                  >
                    <h3 className="text-sm font-semibold text-foreground-900 md:text-base">
                      {item.q}
                    </h3>
                    <span
                      className={`flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700 transition-transform ${
                        open ? "rotate-180" : ""
                      }`}
                    >
                      <i className="ri-arrow-down-s-line text-lg"></i>
                    </span>
                  </button>
                  {open && (
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        }}
      />
    </section>
  );
}